import React from 'react';
import { useDispatch } from "react-redux";
import PropTypes from 'prop-types';
import Select from "react-select";
import { baseSelectStyles } from '../../../shared/selectStyles';
import { setCallingIn, clearCallingIn } from '../../../../ReduxSlices/Patients/patientQueueSlice';

const PatientQueueItem = ({
  entry,  position, patient, onStartVisit, onMarkDone, onRemove,
  onClick, onMarkWaitingLab, onCallIn, canCallIn, canStartVisit, onPay, labBillable,
  selectedConsultation, selectedLab, onServiceChange, consultationServices, role, errorMessage, labTestServices

}) => {
   const dispatch = useDispatch();   
  return (
  <li className=" py-2 px-4 flex justify-between items-center odd:bg-gray-50 even:bg-white">
    <div className="queue-number">
    #{position}
  </div>
    <button
      onClick={onClick}
      className="patient-btn text-left w-full bg-transparent border-none p-0 m-0"
      type="button"
    >
      <span className="patient-name font-semibold">
         {entry.patient?.name || 'Unknown'}
         {entry.intent === 'lab' && (
            <button type="button" className="banner">
              Lab Only
            </button>
        )}
      </span>

      <p className="subtext text-sm italic capitalize">
        {entry.status.replace(/_/g, ' ')}
      </p>
      {entry.called_in && (
        <p className="subtext text-sm  font-semibold">🛎️ Called In</p>
      )}

    </button>
    <div className='flex flex-col'>

          <div className=" buttons flex gap-2">
            {canCallIn && (entry.status === 'waiting' || entry.status === 'waiting_for_lab_results') && !entry.called_in && (
            <button
              onClick={() => {
                   dispatch(setCallingIn(entry.id)); // show calling in immediately
                     onCallIn(entry.id) // trigger API
                    .unwrap()
                    .finally(() => dispatch(clearCallingIn(entry.id))); // remove temp state after response
                  }}
              disabled={entry.callingIn} 
              type="button"
              className="primary text-white px-3 py-1 rounded"
            >
                {entry.callingIn ? "Calling In…" : "Call In"}
            </button>
            )}

          {entry.status === 'waiting' && onPay && (
              entry.consultation_paid ? (
                <span className="primary font-semibold">Consultation Paid</span>
              ) : (
                <div className="flex items-start gap-[10px]">
                <Select
                      value={
                        selectedConsultation
                          ? consultationServices
                              .map((s) => ({ label: `${s.name} (Ksh${s.fee})`, value: s.id }))
                              .find((opt) => opt.value === parseInt(selectedConsultation))
                          : null
                      }
                    onChange={(option) =>
                       onServiceChange(entry.id, option?.value || '', 'consultation')}

                      options={consultationServices.map((s) => ({
                        label: `${s.name} (Ksh${s.fee})`,
                        value: s.id,
                      }))}
                      placeholder="Select Consultation type"
                      isSearchable
                      className="w-[250px]"
                      styles={baseSelectStyles}
                        />

                  <button
                    disabled={!selectedConsultation}
                    onClick={() => onPay('consultation', selectedConsultation)}
                    className={`primary wide text-white bg-green-600 hover:bg-green-700 px-3 py-1 rounded ${
                      !selectedConsultation ? 'opacity-50 cursor-not-allowed' : ''
                    }`}
                  >
                    Pay for Consultation
                  </button>
                </div>
              )
            )}

       {entry.intent === 'lab' && onPay && (
      <div className="flex flex-col gap-2">
          {/* Only show dropdown + pay button if lab is not yet paid */}
          {!entry.lab_paid && (
          <div className="flex items-start gap-[10px]">
            <Select
              value={
                selectedLab
                  ? labTestServices
                      .map((s) => ({ label: `${s.name} (Ksh${s.unit_price})`, value: s.id }))
                      .find((opt) => opt.value === parseInt(selectedLab))
                  : null
              }
              onChange={(option) => {
                  console.log("🧪 LAB SELECTED:", {
                    entryId: entry.id,
                    serviceId: option?.value,
                    serviceName: option?.label,
                  });
                onServiceChange(entry.id, option?.value || null, 'lab')}}
              options={labTestServices.map((s) => ({
                label: `${s.name} (Ksh${s.unit_price})`,
                value: s.id,
              }))}
              placeholder="Select Lab Test"
              isSearchable
              className="w-[250px]"
              styles={baseSelectStyles}
            />
            <button
              disabled={!selectedLab}
              onClick={() => { 
              const selectedTest = labTestServices.find(
                  (s) => s.id === parseInt(selectedLab)
                );

              console.log("💰 PAY CLICKED (LAB):", {
                entryId: entry.id,
                serviceId: selectedLab,
                serviceName: selectedTest?.name,
              })
              
               onPay('lab', selectedLab)}}
              className={`primary wide text-white bg-green-600 hover:bg-green-700 px-3 py-1 rounded ${
                !selectedLab ? 'opacity-50 cursor-not-allowed' : ''
              }`}
            >
              Pay for Lab
            </button>
          </div>
         )}

           {/* Show "Lab Paid" status if already paid */}
           {entry.lab_paid && (
                  <span className="primary text-sm font-semibold text-green-700">
                    Lab Paid
                  </span>
                )}

             </div>
          ) }

          {/* Generic Lab Payment for entries where intent != 'lab' */}
        {entry.intent !== 'lab' && onPay && (entry.status === 'waiting_for_lab_results' || entry.status === 'done') && (
          <>
            {labBillable && (
              <button
                onClick={() => onPay('lab')}
                className="primary extra text-white bg-yellow-600 hover:bg-yellow-700 px-3 py-1 rounded"
              >
                Pay for Lab
              </button>
            )}
            {entry.lab_paid && (
              <span className="primary text-sm font-semibold text-green-700">
                Lab Paid
              </span>
            )}
          </>
        )}


              { entry.lab_results_present && (  
                  <p
                    className="success w-[25%]"
                    >           
                    lab results in
                    </p>
              )}

              {(entry.status === 'done' || entry.status === 'being_seen'  || entry.status === 'waiting_for_lab_results') && onPay && (
              <>
                { entry.has_unpaid_medications && (
                  <button
                    onClick={() => onPay('medication')}
                    className="primary extra bg-blue-600 hover:bg-blue-700 text-white px-3 py-1 rounded"
                  >
                   Pay for Medication
                  </button>
                )}
                {entry.medication_paid && (
                  <span className="primary wide text-sm font-semibold text-green-700">
                    Medication Paid
                  </span>
                )}
              </>
            )}


            {canStartVisit && entry.called_in && entry.status === 'waiting' && (
              <button
                onClick={() => onStartVisit(entry.id)}
                type="button"
                className="primary text-white px-3 py-1 rounded"
              >
                Start Visit
              </button>
            )}

            {entry.status === 'being_seen' && (
              <>
                <button
                  type="button"
                  onClick={() => onMarkWaitingLab(entry.id)}
                  className="primary extra text-white px-2 py-1 rounded hover:bg-yellow-500"
                >
                  Waiting for Lab results
                </button>

                <button
                  onClick={() => onMarkDone(entry.id)}
                  type="button"
                  className="primary text-white px-3 py-1 rounded"
                >
                  Mark Done
                </button>
              </>
            )}

            {entry.status === 'waiting_for_lab_results' && (
            <button
              onClick={() => onMarkDone(entry.id)}
              type="button"
              className="primary text-white px-3 py-1 rounded"
            >
              Mark Done
            </button>
            )}

            {entry.status === 'done' && onPay && entry.any_paid && (
                <button
                  onClick={() => window.open(`/api/v1/patient_queues/${entry.id}/receipt`, '_blank')}
                  type="button"
                  className="primary wide "
                >
                Print Receipt
                </button>
              )}

            {role === 'receptionist' &&(
              <button
                onClick={onRemove}
                disabled={entry.isRemoving}
                type="button"
                className={`primary text-white px-3 py-1 rounded ${
                  entry.isRemoving ? 'opacity-50 cursor-not-allowed' : ''
                }`}
              >
                 {entry.isRemoving ? 'Removing…' : 'Remove'}
              </button>
            )}
          </div>
            {errorMessage && (
              <div className='mt-[5px] error-msg'>
                {errorMessage}
              </div>
            )}
    </div>
  </li>
);
}

PatientQueueItem.propTypes = {
  entry: PropTypes.shape({
    id: PropTypes.number.isRequired,
    patient_id: PropTypes.number.isRequired,
    patient: PropTypes.shape({
    id: PropTypes.number,
    name: PropTypes.string,
  }),
    status: PropTypes.string.isRequired,
    called_in: PropTypes.bool,
  }).isRequired,
  onStartVisit: PropTypes.func.isRequired,
  onMarkWaitingLab: PropTypes.func.isRequired,
  onMarkDone: PropTypes.func.isRequired,
  onRemove: PropTypes.func.isRequired,
  onClick: PropTypes.func.isRequired,
  onCallIn: PropTypes.func.isRequired,
  canCallIn: PropTypes.bool,
  canStartVisit: PropTypes.bool,
  labBillable: PropTypes.bool,
  role: PropTypes.string,
};

PatientQueueItem.defaultProps = {
  canCallIn: false,
  canStartVisit: false,
  labBillable: false,
  consultationServices: [],
  selectedLab: '',
  selectedConsultation: '',
  role: '',
  onServiceChange: () => {},
};

export default PatientQueueItem;
